import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  STATIC_PAGE_SEO,
  applyPageSeo,
  getNoindexSeo,
  isNoindexPath,
} from '../utils/pageSeo';

/** Static routes + noindex utility pages (product/category/blog set their own SEO). */
const MANAGED_STATIC = new Set(Object.keys(STATIC_PAGE_SEO));

export default function PageSeoManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (isNoindexPath(pathname)) {
      return applyPageSeo(getNoindexSeo(pathname));
    }

    if (MANAGED_STATIC.has(pathname)) {
      return applyPageSeo(STATIC_PAGE_SEO[pathname]);
    }

    return undefined;
  }, [pathname]);

  return null;
}
